import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientBoard } from '../../../model/client-model/client-board';
import { RecursivePropOfBoard } from '../../../store/board/board.actions';
import { BackendBoardsService } from '../../backend/backend-boards.service';
import { BoardSaveManagerService } from './board-save-manager.service';

@Injectable({
  providedIn: 'root',
  useClass: BoardSaveManagerService,
  deps: [BackendBoardsService, Injector],
})
export abstract class IBoardSaveManagerService {
  public abstract queueBoardForSaving({
    boardId,
    tenantId,
    updates,
    board,
  }: {
    boardId: string;
    tenantId: string;
    updates: {
      property: RecursivePropOfBoard;
      value: any;
    }[];
    board: ClientBoard;
  }): Observable<ClientBoard>;
}
